import React from 'react';
import { MessageCircle, MapPin, UserRoundPlus, Building2 } from 'lucide-react';
import LandingSection from './LandingSection';
import Reveal from './Reveal';
import { useT } from './i18n';

const icons = [MessageCircle, MapPin, UserRoundPlus, Building2];

const LandingUseCases = () => {
  const t = useT();
  const items = t('useCases.items');

  return (
    <LandingSection variant="gray">
      <Reveal>
        <div className="landing-section-intro landing-section-intro--center">
          <h2 className="landing-h2">{t('useCases.title')}</h2>
          <p className="landing-text landing-text--center" style={{ marginBottom: 0 }}>
            {t('useCases.intro')}
          </p>
        </div>
      </Reveal>

      <div className="landing-usecases-grid">
        {items.map((item, index) => {
          const Icon = icons[index];
          return (
            <Reveal key={item.title} delay={index * 0.05}>
              <article className="landing-usecase-card">
                <div className="landing-feature-card__icon">
                  <Icon size={22} strokeWidth={1.75} aria-hidden />
                </div>
                <h3 className="landing-feature-card__title">{item.title}</h3>
                <p className="landing-feature-card__text">{item.description}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </LandingSection>
  );
};

export default LandingUseCases;
